import React, { useEffect, useState } from 'react';
import { Rocket, Sparkles, X } from 'lucide-react';

// Accueil : Nexus propose un kickoff aux seconds d'un projet (sinon au leader) quand un sprint est en cours sans
// objectif ou qu'une itération est en cours sans sprint (GET /home/overview → kickoffs, services/kickoff_hints.py).
// « Plus tard » écarte le projet pour la journée ; Nexus le repropose le lendemain si rien n'a bougé.

const laterKey = (day) => `deepflow.home.kickoffs.later.${day}`;

const readLater = (day) => {
  try {
    return new Set(JSON.parse(localStorage.getItem(laterKey(day)) || '[]'));
  } catch (err) {
    return new Set();
  }
};

const KickoffHints = ({ hints, today, navigate }) => {
  const [later, setLater] = useState(() => readLater(today));
  useEffect(() => { setLater(readLater(today)); }, [today]);

  const shown = (hints || []).filter((h) => !later.has(h.project_id));
  if (!shown.length) return null;
  const postpone = (projectId) => {
    const next = new Set([...later, projectId]);
    setLater(next);
    try {
      localStorage.setItem(laterKey(today), JSON.stringify([...next]));
    } catch (err) {
      // stockage indisponible : écarté pour cette visite seulement
    }
  };

  return (
    <section className="rounded-2xl border border-indigo-200 bg-white px-4 py-3 shadow-sm sm:px-5">
      <div className="flex items-center gap-3">
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-indigo-600 text-white shadow-sm shadow-indigo-200">
          <Sparkles size={15} />
        </span>
        <p className="text-[11px] font-semibold uppercase tracking-wide text-indigo-500">
          Kickoff à faire{shown.length > 1 ? ` · ${shown.length} projets` : ''}
        </p>
      </div>
      <ul className="mt-2 divide-y divide-slate-100 sm:pl-11">
        {shown.map((hint) => (
          <li key={hint.project_id} className="flex flex-wrap items-center gap-x-3 gap-y-1.5 py-2 first:pt-0 last:pb-0 sm:flex-nowrap">
            <p className="min-w-0 basis-full text-sm leading-relaxed text-slate-700 sm:flex-1 sm:basis-auto">
              <span className="font-semibold text-slate-900">{hint.project_name}</span>
              {' : '}{hint.reasons.map((r) => r.text).join(' ; ')}.
            </p>
            <div className="flex shrink-0 items-center gap-1">
              <button type="button" onClick={() => navigate(`/project/${hint.project_id}/kickoff`)}
                className="flex items-center gap-1.5 rounded-lg bg-indigo-600 px-3 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-700">
                <Rocket size={14} /> Lancer le kickoff
              </button>
              <button type="button" onClick={() => postpone(hint.project_id)} title="Plus tard (écarté jusqu’à demain)"
                className="rounded-md p-1.5 text-slate-300 hover:bg-slate-100 hover:text-slate-500">
                <X size={14} />
              </button>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default KickoffHints;
